import { useContext } from 'external/react'
import { purchaseService } from 'services/purchase.service'
import { userService } from 'services/user.service'

import Package from 'context/package-context'
import useAuth from 'context/auth-context/hook'


export default function usePackage() {

    const {user} = useAuth()

	const {state, update} = useContext(Package.Context);

    function setSavingStatus(id: string, delay:number, status:boolean, ...names:string[]) {
        const statusName = names.join('_')
        setTimeout(() => {
            update({saving: {[id]: {$auto: {[statusName]: {$set: status}}}}})
        }, delay)
    }

    async function assignUserToPackage (role:string, profileId:string, purchaseItemId:string) {
        setSavingStatus(purchaseItemId, 0, true, 'assigning', role.toLowerCase())
        await purchaseService.assignPurchaseItemUser({role: role.toLowerCase(), purchaseItemId, profileId, clientId: user.id})
        setSavingStatus(purchaseItemId, 100, false, 'assigning', role.toLowerCase())
    }

    async function addUser(role:string, newUser:any) {
       return userService.create({...newUser, client_id: user.id, role}) 
    }

    async function savePackage() {
        const purchaseItemUser = {
            purchaseItemId: state.packageItem.data?.id,
            studentId: state.packageItem.data?.student?.id,
            tutorId: state.packageItem.data?.tutor?.id,
            clientId: user.id
        } 
        return state.packageItem.data?.assigned
            ? purchaseService.updatePurchaseItemUser(purchaseItemUser)
            : purchaseService.createPurchaseItemUser(purchaseItemUser)
    }

    const selectedTutor = state.packageItem.data?.tutor
    const selectedStudent = state.packageItem.data?.student
    const isAssigned = state.packageItem.data?.assigned
    const basic = state.packageItem.courses.basic
    const elective = state.packageItem.courses.elective

    return {
        state,
        update,
        addUser,
        savePackage,
        assignUserToPackage,
        basic,
        elective,
        isAssigned,
        selectedTutor,
        selectedStudent
    }
}